import { createTheme } from '@mui/material/styles'

// Audio Normalizer inspired dark theme for Multizone Player
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4A90C2',
      light: '#5BA3D4',
      dark: '#2E86AB'
    },
    secondary: {
      main: '#1F5F99',
      light: '#4A90C2',
      dark: '#1A4A73'
    },
    background: {
      default: '#0f172a',
      paper: 'rgba(255, 255, 255, 0.08)'
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)'
    },
    error: {
      main: '#ef4444'
    },
    warning: {
      main: '#f59e0b'
    },
    info: {
      main: '#06b6d4'
    },
    success: {
      main: '#10b981'
    }
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
      fontSize: '3.5rem'
    },
    h2: {
      fontWeight: 800,
      fontSize: '2.5rem'
    },
    h3: {
      fontWeight: 700,
      fontSize: '2rem'
    },
    h4: {
      fontWeight: 700,
      fontSize: '1.5rem'
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem'
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem'
    },
    button: {
      textTransform: 'none',
      fontWeight: 600
    }
  },
  shape: {
    borderRadius: 16
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
          minHeight: '100vh'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.08)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '16px'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          textTransform: 'none',
          fontWeight: 600
        },
        contained: {
          background: 'linear-gradient(135deg, #4A90C2, #2E86AB)',
          boxShadow: '0 4px 12px rgba(74, 144, 194, 0.3)',
          '&:hover': {
            background: 'linear-gradient(135deg, #5BA3D4, #4A90C2)',
            boxShadow: '0 6px 16px rgba(74, 144, 194, 0.4)'
          }
        },
        outlined: {
          borderColor: 'rgba(255, 255, 255, 0.3)',
          color: '#ffffff',
          '&:hover': {
            borderColor: '#4A90C2',
            background: 'rgba(74, 144, 194, 0.1)'
          }
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(15, 23, 42, 0.8)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }
      }
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          position: 'relative',
          zIndex: 1
        }
      }
    }
  }
})

export default theme
